import { CalendarToday, LibraryAddCheck, Public } from "@mui/icons-material";
import { Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { tokens } from "../../../store/tokens";

const Row = ({ icon, label, value }) => (
  <Stack
    direction={"row"}
    justifyContent="space-between"
    alignItems={"center"}
    sx={{ width: "100%" }}
  >
    <Stack direction={"row"} spacing={1} alignItems={"center"}>
      {icon}
      <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
        {label}
      </Typography>
    </Stack>
    <Typography
      variant="body2"
      sx={{ color: tokens.color.ink, fontWeight: 600, textAlign: "right" }}
    >
      {value ?? "—"}
    </Typography>
  </Stack>
);

const BasicInfo = (props) => {
  const { profileDetails } = props;
  const { language, previous_work, reg_date } = profileDetails;
  const iconSx = { fontSize: "1.1rem", color: tokens.color.teal };

  return (
    <Paper
      elevation={0}
      sx={{
        padding: `${tokens.card.padding.md}px`,
        borderRadius: `${tokens.card.radius}px`,
        border: `1px solid ${tokens.color.line}`,
        bgcolor: tokens.color.surface,
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" sx={{ color: tokens.color.ink }}>
          Basic Info
        </Typography>
        <Row
          icon={<CalendarToday sx={iconSx} />}
          label="Career start"
          value={reg_date}
        />
        <Row
          icon={<Public sx={iconSx} />}
          label="Language"
          value={language}
        />
        <Row
          icon={<LibraryAddCheck sx={iconSx} />}
          label="Previous work"
          value={previous_work}
        />
      </Stack>
    </Paper>
  );
};

export default BasicInfo;
